import SingleBarChart from "@/components/visualizations/SingleBarChart.tsx/SingleBarChart";
import Widget from "@/pages/dashboard/components/Widget/Widget";
import { ProductBy, useProductUsageImpactCompare } from "@/pages/dashboard/hooks/useProductImpact";
import { ImpactMetric } from "@/pages/dashboard/utils/types";

function ProductUsageImpactPerType({
  metric,
  productId,
  by,
}: {
  metric: ImpactMetric;
  productId: number;
  by: ProductBy;
}) {
  const { data, isLoading, isFetching } = useProductUsageImpactCompare({
    productId,
    by,
    metric: metric.key,
  });

  const electricity_impact = data?.electricity
    ? {
        label: "Electricity",
        value: data.electricity[metric.key],
      }
    : null;

  const consumable_impact = data?.consumables
    ? {
        label: "Consumables",
        value: data.consumables[metric.key],
      }
    : null;

  const chartData = [
    ...(electricity_impact ? [electricity_impact] : []),
    ...(consumable_impact ? [consumable_impact] : []),
  ];

  return (
    <Widget
      title={"Usage impact per type"}
      tooltip={"The total usage footprint, split up into electricity and consumable usage"}
    >
      <SingleBarChart
        data={chartData}
        format={metric.formatter}
        loading={isLoading || isFetching}
      />
    </Widget>
  );
}

export default ProductUsageImpactPerType;
